export const openWorkspaceText = {
  workspace: 'My Workspace',
};
